import React from 'react'
import {getExchangeIcon} from './commonUtils'

export const ExchangeIcon = ({ exchange }) => {
    const iconFile = getExchangeIcon(exchange);
    if (!iconFile) {
        return;
    }

    // アイコンを表示
    return <img src={iconFile} alt={`${exchange} flag`} className='w-[30px] h-[auto] pb-1' />;
};

export default ExchangeIcon